import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('League-index-1992f2b75fcabd476-1'),
    routerUrl: '/League',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./League')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('League-index-1992f2b75fcabd476-2'),
        routerUrl: '/LeagueForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./LeagueForm')),
      },
      //$MORE$
    ],
  },
];
